export const companyDetails = {
  legalName: "Monra Labs Ltd",
  companyNumber: "",
  registeredOfficeAddress: "",
  registeredJurisdiction: "",
  contactEmail: "support@monralabs.com",
} as const

export const companyDisclosureLines = [
  { label: "Registered name", value: companyDetails.legalName },
  { label: "Company number", value: companyDetails.companyNumber },
  { label: "Registered office", value: companyDetails.registeredOfficeAddress },
  { label: "Registered in", value: companyDetails.registeredJurisdiction },
] as const
